import { useState, useMemo } from "react";
import {
  Button,
  Checkbox,
  Col,
  Divider,
  Row,
  Select,
  Space,
  Typography,
} from "antd";
import ListInput from "./components/Input";
import ListSelect from "./components/Select";
import ListDatePicker from "./components/DatePicker";
import NumericInput from "./components/NumericInput";
import { name_regexp, special_characters_regexp } from "helpers/regexp";
import { useSettlement } from "context/providers/settlement";
import RangePicker from "./components/RangePicker";

const getRegexp = (name) => {
  switch (name) {
    case "name":
    case "first_name":
    case "last_name":
      return name_regexp;
    case "ip_address":
      return new RegExp(/^[0-9.]{0,20}$/);
    case "post_code":
      return new RegExp(/^[0-9-]{0,6}$/);
    default:
      return special_characters_regexp;
  }
};

const IssueFilters = () => {
  const [show_columns, setShowColumns] = useState(false);
  const {
    columns,
    query,
    setQuery,
    search_values,
    handleSetSearchValues,
    paginate,
    setPaginate,
    handleReset,
    total_count,
    checked_list,
    updateCheckedList,
    checked_list_options,
  } = useSettlement();

  const onSearch = ({ name, value, search_method }) =>
    setQuery({
      ...query,
      [name]: { value, search_method },
    });

  const sort_options = useMemo(() => {
    const data = [];
    columns
      .filter(({ sortable }) => sortable)
      .forEach(({ dataIndex, title }) => {
        data.push({
          label: `${title} malejąco`,
          value: `${dataIndex}__desc`,
        });
        data.push({
          label: `${title} rosnąco`,
          value: `${dataIndex}__asc`,
        });
      });
    return data;
  }, [columns]);

  return (
    <>
      <Row gutter={[12, 12]}>
        {columns
          .filter(({ searchable }) => searchable)
          .map(
            ({
              title,
              dataIndex: name,
              search_component = "input",
              search_type = "text",
              search_method,
              options = [],
            }) => (
              <Col xs={24} md={12} lg={4} xl={4} key={name}>
                {search_component === "input" &&
                  (search_type === "number" ? (
                    <NumericInput
                      search_type={search_type}
                      title={title}
                      value={search_values?.[name] || ""}
                      onChange={(value) =>
                        handleSetSearchValues({
                          ...search_values,
                          [name]: value,
                        })
                      }
                      onBlur={() =>
                        onSearch({
                          name,
                          search_method,
                          value: search_values?.[name],
                        })
                      }
                      onPressEnter={() =>
                        onSearch({
                          name,
                          search_method,
                          value: search_values?.[name],
                        })
                      }
                    />
                  ) : (
                    <ListInput
                      search_type={search_type}
                      regexp={getRegexp(name)}
                      title={title}
                      value={search_values?.[name] || ""}
                      onChange={(value) =>
                        handleSetSearchValues({
                          ...search_values,
                          [name]: value,
                        })
                      }
                      onBlur={() =>
                        onSearch({
                          name,
                          search_method,
                          value: search_values?.[name],
                        })
                      }
                      onPressEnter={() =>
                        onSearch({
                          name,
                          search_method,
                          value: search_values?.[name],
                        })
                      }
                    />
                  ))}
                {search_component === "select" && (
                  <ListSelect
                    title={title}
                    options={options}
                    value={search_values?.[name]}
                    onChange={(value) => [
                      handleSetSearchValues({
                        ...search_values,
                        [name]: value,
                      }),
                      onSearch({
                        name,
                        search_method,
                        value,
                      }),
                    ]}
                  />
                )}
                {search_component === "date-picker" && (
                  <ListDatePicker
                    title={title}
                    value={search_values?.[name]}
                    onChange={(value) => [
                      handleSetSearchValues({
                        ...search_values,
                        [name]: value,
                      }),
                      onSearch({
                        name,
                        search_method,
                        value,
                      }),
                    ]}
                  />
                )}
                {search_component === "range-picker" && (
                  <RangePicker
                    title={title}
                    value={search_values?.[name]}
                    onChange={(value) => [
                      handleSetSearchValues({
                        ...search_values,
                        [name]: value,
                      }),
                      onSearch({
                        name,
                        search_method,
                        value,
                      }),
                    ]}
                  />
                )}
              </Col>
            )
          )}
      </Row>
      <Row
        gutter={[12, 12]}
        justify="space-between"
        style={{
          marginTop: "20px",
          marginBottom: "20px",
        }}
      >
        <Col xs={24} md={12} lg={6} xl={4}>
          <Select
            allowClear
            style={{
              width: "100%",
              display: "block",
              minWidth: 240,
            }}
            placeholder="Sortuj"
            value={sort_options.find(({ value }) => value === paginate?.sort)}
            onChange={(value) => {
              setPaginate({
                ...paginate,
                page: undefined,
                sort: value,
              });
            }}
            options={sort_options}
          />
        </Col>
        <Col xs={24} md={12} lg={8} xl={8} style={{ textAlign: "right" }}>
          <Space>
            <Typography.Text>Ilość: {total_count}</Typography.Text>
            <Button type="primary">Szukaj</Button>
            <Button onClick={handleReset}>Resetuj</Button>
            <Button onClick={() => setShowColumns(!show_columns)}>
              {!show_columns ? "Pokaż" : "Ukryj"} kolumny
            </Button>
          </Space>
        </Col>
      </Row>
      {show_columns && (
        <>
          <Divider />
          <Checkbox.Group
            value={checked_list}
            options={checked_list_options}
            onChange={updateCheckedList}
          />
          <Divider />
        </>
      )}
    </>
  );
};

export default IssueFilters;
